module.exports = __webpack_public_path__ + "img/mzcr.6cbfad43.gif";